import axios from 'axios'

var host = process.env.VUE_APP_API_HOST

export const templateServices = {
  getTemplates,
  duplicate
}

// Gets only Active Templates
function getTemplates () {
  return axios
    .get(`${host}/api/Module`)
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function duplicate (template) {
  var req = {
    moduleId: template.id,
    newTitle: template.title + ' - Copy'
  }
  return axios
    .post(`${host}/api/Module/duplicate`, req)
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}
